module.exports = __webpack_public_path__ + "47919954f7ba47cacc2aa1b4e0ba48ad.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/businessanalysishero.jpg
// module id = 78
// module chunks = 0